import React from "react";
import { NativeBaseProvider } from "native-base";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./store/store";
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import "./index.css";
import "./index_dashboard.css";

if (window.top !== window.self) {
  window.top.location = window.self.location;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <NativeBaseProvider>
      <App />
    </NativeBaseProvider>
  </Provider>
);
